let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fpIkZ")).then(() => parcelRequire('24CIW'));